module.exports = __webpack_public_path__ + "img/kid-blue.b576cbbf.svg";